import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ArrowDownToLine, ArrowUpToLine, Pencil } from "lucide-react";
import { MdCancel } from "react-icons/md";

import css from './DishSemiFinish.module.css';
import { dishSemiFinishedActions } from "../../../../store/slices/dishes-slices";
import { DishUpdateSemiFinishModal } from "../DishAddSemiFinishModal/DishUpdateSemiFinishModal";


const DishSemiFinish = ({ dishSemiFinish, index }) => {
    const dispatch = useDispatch();
    const { id, name, weight, cost, weightNetto, energy, proteins, fats, carbohydrates } = dishSemiFinish;

    const { dishSemiFinishedModalArray } = useSelector(store => store.dishSemiFinished);

    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name['en'];

    const [isOpenUpdate, setIsOpenUpdate] = useState(false);

    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };

    const deleteDishSemiFinish = () => {
        dispatch(dishSemiFinishedActions.removeDishSemiFinishForModal(id));
    };

    const handleUpClick = () => {
        if (index === 0) return;
        const newArray = [...dishSemiFinishedModalArray];
        newArray.splice(index, 1);
        newArray.splice(index - 1, 0, dishSemiFinishedModalArray[index]);
        dispatch(dishSemiFinishedActions.updateDishSemiFinishedForModal(newArray));
    };

    const handleDownClick = () => {
        if (index === dishSemiFinishedModalArray.length - 1) return;
        const newArray = [...dishSemiFinishedModalArray];
        newArray.splice(index, 1);
        newArray.splice(index + 1, 0, dishSemiFinishedModalArray[index]);
        dispatch(dishSemiFinishedActions.updateDishSemiFinishedForModal(newArray));
    };

    return (
        <section className={css.wrap}>
            <div className={css.product}>
                {displayName}

                <div className={css.nutritionGrid}>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>E:</span>
                        <span className={css.nutritionValue}>{energy || 0} kcal</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>P:</span>
                        <span className={css.nutritionValue}>{proteins || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>F:</span>
                        <span className={css.nutritionValue}>{fats || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>C:</span>
                        <span className={css.nutritionValue}>{carbohydrates || 0} g</span>
                    </div>
                </div>
            </div>
            <div className={css.weight}>{weight}</div>
            <div className={css.weightNetto}>{weightNetto}</div>
            <div className={css.price}>{cost}</div>
            <div className={css.index}>
                {index > 0 && <ArrowUpToLine size={16} onClick={handleUpClick} />}
                {index !== dishSemiFinishedModalArray.length - 1 && (
                    <ArrowDownToLine size={16} onClick={handleDownClick} />
                )}
            </div>
            <div className={css.actions}>
                <div className={css.updateButton} onClick={handleUpdateClick}>
                    <Pencil size={16} />
                </div>
                <div className={css.deleteButton} onClick={deleteDishSemiFinish}>
                    <MdCancel size={16} />
                </div>
            </div>

            {isOpenUpdate && (
                <DishUpdateSemiFinishModal
                    semiFinishedId={dishSemiFinish.semiFinishedId ?? id}
                    setDishSemiFinishUpdateOpen={setIsOpenUpdate}
                    weight={weight}
                    weightNetto={weightNetto}
                />
            )}
        </section>
    );
};

export default DishSemiFinish;
